export default {
  /////////////////
  // PDK
  /////////////////

  SET_PDK_COMPONENTS(state, pdk) {
    state.pdkComponents = pdk;
  },
  EDIT_PDK_COMPONENTS(state, payload) {
    let pdkItem = state.pdkComponents.results.find(u => u.id === payload.id);
    // console.log(state.pdkComponents.results);
    // console.log(payload);
    pdkItem.value = payload.value;
  },
  /////////////////
  // KEN
  /////////////////

  SET_KEN_COMPONENTS(state, ken) {
    state.kenComponents = ken;
  },
  EDIT_KEN_COMPONENTS(state, payload) {
    let kenItem = state.kenComponents.results.find(u => u.id === payload.id);
    kenItem.value = payload.value;
  },

  /////////////////
  // GET COMPONENTS
  /////////////////

  SET_LIBRARIES_GET_COMPONENTS(state, libraries) {
    state.getComponets = libraries;
  },
  ADD_LIBRARY_GET_COMPONENTS(state, library) {
    state.getComponets.push(library);
  },
  EDIT_LIBRARY_GET_COMPONENTS(state, value) {
    const userIndex = state.getComponets.findIndex(u => u.id === value.id);
    state.getComponets.splice(userIndex, 1, value);
  },
  SET_LIBRARIES_COMPONENTS_BY_GROUP_ID(state, value) {
    let obj = new Object(); //создаю объект из данных пришедших с бэка чтобы добавить в  стор
    obj.group_id = value.group_id; // добавляю в объект group_id
    obj.data = value.data; // обавляю в объект данные пришедшие из бэка

    //проверяю есть ли в сторе объект с таким же group_id
    const groupComponentsIndex = state.getComponetsByGroup.findIndex(
      u => u.group_id === value.group_id
    );
    //если в сторе нет объекта с таким же group_id то добавляю в стор
    if (groupComponentsIndex === -1) {
      state.getComponetsByGroup.push(obj);
    } else {
      //если в сторе есть  объекта с таким же group_id то заменяю его тем что пришел из бэка стор
      state.getComponetsByGroup.splice(groupComponentsIndex, 1, obj);
    }
  },
  EDIT_LIBRARIES_COMPONENTS_BY_GROUP_ID(state, value) {
    const groupIndex = state.getComponetsByGroup.findIndex(
      u => u.group_id === value.group_id
    );
    const componentIndex = state.getComponetsByGroup[groupIndex].data.findIndex(
      u => u.id === value.id
    );
    state.getComponetsByGroup[groupIndex].data.splice(componentIndex, 1, value);
  },

  /////////////////
  // MEASURMENT UNITS
  /////////////////
  SET_LIBRARIES_MEASURMENT_UNITS(state, libraries) {
    state.measurmentUnits = libraries;
  },
  ADD_LIBRARY_MEASURMENT_UNITS(state, library) {
    state.measurmentUnits.push(library);
  },
  EDIT_LIBRARY_MEASURMENT_UNITS(state, value) {
    const muIndex = state.measurmentUnits.findIndex(u => u.id === value.id);
    state.measurmentUnits.splice(muIndex, 1, value);
  },


  /////////////////
  // ECOLOGY_TYPE
  /////////////////

  SET_LIBRARY_ECOLOGY_TYPE(state, libraries) {
    state.ecologyType = libraries;
  },
  ADD_LIBRARY_ECOLOGY_TYPE(state, library) {
    state.ecologyType.push(library);
  },
  EDIT_LIBRARY_ECOLOGY_TYPE(state, value) {
    const muIndex = state.ecologyType.findIndex(u => u.id === value.id);
    state.ecologyType.splice(muIndex, 1, value);
  },

  /////////////////
  // SUBORDINATION
  /////////////////

  SET_LIBRARIES_SUBORDINATION(state, libraries) {
    state.subordination = libraries;
  },

  /////////////////
  // OWNERSHIP
  /////////////////

  SET_LIBRARIES_OWNERSHIP(state, libraries) {
    state.ownership = libraries;
  },
  ADD_LIBRARY_OWNERSHIP(state, library) {
    state.ownership.push(library);
  },
  EDIT_LIBRARY_OWNERSHIP(state, value) {
    const muIndex = state.ownership.findIndex(u => u.id === value.id);
    state.ownership.splice(muIndex, 1, value);
  },

  /////////////////
  // ActivityField
  /////////////////

  SET_LIBRARIES_ACTIVITY_FIELD(state, libraries) {
    state.activityField = libraries;
  },
  ADD_LIBRARY_ACTIVITY_FIELD(state, library) {
    state.activityField.push(library);
  },
  EDIT_LIBRARY_ACTIVITY_FIELD(state, value) {
    const muIndex = state.activityField.findIndex(u => u.id === value.id);
    state.activityField.splice(muIndex, 1, value);
  },

  /////////////////
  // Departments
  /////////////////

  SET_LIBRARIES_DEPARTMENTS(state, library) {
    state.departments = library;
  },
  ADD_LIBRARY_DEPARTMENTS(state, library) {
    state.departments.push(library);
  },
  EDIT_LIBRARY_DEPARTMENTS(state, value) {
    const muIndex = state.departments.findIndex(u => u.id === value.id);
    state.departments.splice(muIndex, 1, value);
  },

  /////////////////
  // Regions
  /////////////////
  SET_LIBRARIES_PARENT_REGIONS(state, library) {
    // let newList = [...library];
    // newList.sort((a, b) => a.region_kir.localeCompare(b.region_kir)); // сортирую список по алфавиту
    //
    // const ind = newList.findIndex(el =>
    //   el.region_kir.toLowerCase().startsWith("республика")
    // ); //на хожу элемент который начинается с 'республика'
    // let repub = newList.splice(ind, 1); // вырезаю этот элемент из массива
    //
    // const tasInd = newList.findIndex(el =>
    //   el.region_kir.toLowerCase().startsWith("г.")
    // ); //на хожу элемент который начинается с 'г.'
    // let tash = newList.splice(tasInd, 1); // вырезаю этот элемент из массива
    //
    // const allInd = newList.findIndex(el => el.id === 999); //на хожу элемент который Все регионы (id = 999)
    // let allR = newList.splice(allInd, 1); // вырезаю этот элемент из массива
    //
    // newList.unshift(...repub); // добавляю республика каракалпакстан в начало списка
    // newList.splice(11, 0, ...tash); // добавляю город ташкент после ташкентской области
    // newList.push(...allR); // добавляю Все регионы в конец списка

    state.parentRegions = library;
  },
  SET_LIBRARIES_CHILD_REGIONS(state, library) {
    state.childRegions = library;
  },
  SET_LIBRARIES_ALL_REGIONS(state, library) {
    state.allRegions = library;
  },

  /////////////////
  // SourceParameters
  /////////////////

  SET_LIBRARIES_SOURCE_PARAMETERS(state, library) {
    state.sourceParameters = library;
  },
  ADD_LIBRARY_SOURCE_PARAMETERS(state, library) {
    state.sourceParameters.push(library);
  },
  EDIT_LIBRARY_SOURCE_PARAMETERS(state, value) {
    const muIndex = state.sourceParameters.findIndex(u => u.id === value.id);
    state.sourceParameters.splice(muIndex, 1, value);
  },

  /////////////////
  // ObjectsParameters
  /////////////////

  SET_LIBRARIES_OBJECTS_PARAMETERS(state, library) {
    state.objectsParameters = library;
  },
  ADD_LIBRARY_OBJECTS_PARAMETERS(state, library) {
    state.objectsParameters.push(library);
  },
  EDIT_LIBRARY_OBJECTS_PARAMETERS(state, value) {
    const muIndex = state.objectsParameters.findIndex(u => u.id === value.id);
    state.objectsParameters.splice(muIndex, 1, value);
  },
  /////////////////
  // MINISTRY
  /////////////////

  SET_LIBRARIES_MINISTRY(state, library) {
    state.ministry = library;
  },
  ADD_LIBRARY_MINISTRY(state, library) {
    state.ministry.push(library);
  },
  EDIT_LIBRARY_MINISTRY(state, value) {
    const muIndex = state.ministry.findIndex(u => u.id === value.id);
    state.ministry.splice(muIndex, 1, value);
  },

  /////////////////
  // GROUP COMPONENTS
  /////////////////

  SET_LIBRARIES_GROUP_COMPONENTS(state, library) {
    state.groupComponents = library;
  },
  ADD_LIBRARY_GROUP_COMPONENTS(state, library) {
    state.groupComponents.push(library);
  },
  EDIT_LIBRARY_GROUP_COMPONENTS(state, value) {
    const muIndex = state.groupComponents.findIndex(u => u.id === value.id);
    state.groupComponents.splice(muIndex, 1, value);
  }

  ////////////////////////////////////////////////////////
};
